<template>
  <div v-if="showPlans" class="s-plans-container-comp s-form-col" >

    <section class="s-plans-container-upgrade-title">
      <span class="plans-title start" v-if="planSubscribed === 'start' && planSelected !== 'lite'">{{ $t('plans-container.sign-up-title') }}
        <s-button class="s-button-upgrade premium s-no-pointer s-no-border" iconImage="SVG/plan_premium_logo_SVG.svg" v-if="planSubscribed === 'start' && planSelected !== 'lite'">{{ $t('actions.seedr-premium') }}</s-button>
      </span>

      <span class="plans-title start-lite" v-if="planSelected === 'lite'">{{ $t('plans-container.start-using-title') }}
        <s-button class="s-button-upgrade lite s-no-pointer  s-no-border" iconImage="SVG/plan_lite_logo_SVG.svg">{{ $t('actions.lite') }}</s-button><br>
      </span>

      <span class="plans-title subscribed" v-if="planSubscribed === 'trial' && planSelected !== 'lite'">{{ $t('plans-container.using-seedr-trial-title') }}
        <s-button class="s-button-upgrade trial s-no-pointer" iconFont="s-icon-plan-trial">{{ $t('actions.trial') }}</s-button>
      </span>

      <span class="plans-title subscribed" v-if="planSubscribed === 'lite'">{{ $t('plans-container.using-seedr-lite-title') }}
        <s-button class="s-button-upgrade lite s-no-pointer" iconImage="SVG/plan_lite_logo_SVG.svg">{{ $t('actions.lite') }}</s-button>
      </span>

      <span class="plans-title" v-if="planSubscribed === 'basic' || planSubscribed === 'pro' || planSubscribed === 'master'">{{ $t('plans-container.congratulations-title') }}
      <span class="s-text-premium">{{ $t('plans-container.seedr-premium-title') }}</span><s-icon iconImage="SVG/plan_premium_logo_SVG.svg"></s-icon></span>
      <br>
      <span class="plans-title features"  v-if="planSubscribed !== 'start' && planSubscribed !== 'master' && planSelected !== 'lite'">{{ $t('plans-container.get-more-features-title') }}</span>
    </section>

    <section class="s-plan-container-details-parent">
      <s-plan-details
          @planSelected="$emit('planSelected', planSelected = 'master') "
          :isSelected="planSelected === 'master'"
          planName="master"
          :togglePrice="togglePrice"
          :isSubscribed="planSubscribed === 'master'"
          v-if="planSelected !== 'lite'"
      ></s-plan-details>

      <s-plan-details
          @planSelected="$emit('planSelected', planSelected = 'pro')"
          :isSelected="planSelected === 'pro'"
          planName="pro"
          :togglePrice="togglePrice"
          :isSubscribed="planSubscribed === 'pro'"
          v-if="planSelected !== 'lite'"
      ></s-plan-details>

      <s-plan-details
          @planSelected="$emit('planSelected', planSelected = 'basic')"
          :isSelected="planSelected === 'basic'"
          planName="basic"
          :togglePrice="togglePrice"
          :isSubscribed="planSubscribed === 'basic'"
          v-if="planSelected !== 'lite'"
      ></s-plan-details>

      <s-plan-details
          @planSelected="$emit('planSelected', planSelected = 'lite')"
          :isSelected="planSelected === 'lite'"
          planName="lite"
          :togglePrice="togglePrice"
          :isSubscribed="planSubscribed === 'lite'"
          v-if="planSelected === 'lite'"
      ></s-plan-details>
      <span v-if="planSelected === 'lite'" class="get-more">{{ $t('plans-container.or-get-more-features-title') }}<br><s-button @click="$emit('planSelected', planSelected = 'pro')" class="s-button-upgrade premium" iconImage="SVG/plan_premium_logo_SVG.svg">{{ $t('actions.premium') }}</s-button></span>
    </section>

<!--    <section class="s-plans-container-upgrade-title lite " v-if="planSelected === 'lite'">-->
<!--      <span class="plans-title">{{ $t('plans-container.or-get-more-features-title') }}</span>-->
<!--      <s-button @click="$emit('planSelected', planSelected = 'pro')" class="s-button-upgrade premium" iconImage="SVG/plan_premium_logo_SVG.svg">{{ $t('actions.premium') }}</s-button>-->
<!--    </section>-->

    <section class="s-plans-container-toggle">
      <span @click="togglePrice = false" class="s-margin-l-auto  monthly s-transition-03 " :class="[{'active' : !togglePrice}, {'s-pointer' : togglePrice}]">{{ $t('plans-container.monthly-title') }}</span>
      <s-toggle  v-model="togglePrice" class="s-toggle-small s-toggle-ant-invert s-toggle-blue"/>
      <span @click="togglePrice = true" class="s-margin-r-auto  annually s-transition-03" :class="[{'active' : togglePrice}, {'s-pointer' : !togglePrice}]">{{ $t('plans-container.annually-title') }}<br><small>{{ $t('plans-container.two-months-free-text') }}</small></span>
    </section>

    <s-plan-features
        :planSubscribed="planSubscribed"
        :planSelected="planSelected"
        :togglePrice="togglePrice"
    ></s-plan-features>

    <section class="s-plans-container-storage-title" v-if="planSelected === 'master'">
      <span class="plans-title">{{ $t('plans-container.add-storage-extension-title') }}</span>
    </section>

    <section class="s-plans-container-storage s-no-select" v-if="planSelected === 'master'">
      <div  class="s-plans-container-storage-child">
        <input @click="$emit('storageSelected', storageSelected === '1' ? storageSelected = 0 : storageSelected = '1')"  class="s-pointer" type="radio" id="1" value="1" v-model="storageSelected"/>
        <label class="s-pointer" :class="[{'label-active' : storageSelected === '1'}]" for="1">1TB</label>
        <s-badge class="s-badge-green">{{ !togglePrice ? '$35' : '$350' }}</s-badge>
      </div>

      <div  class="s-plans-container-storage-child">
        <input @click="$emit('storageSelected',storageSelected === '2' ? storageSelected = 0 : storageSelected = '2')" class="s-pointer" type="radio" id="2" value="2" v-model="storageSelected" />
        <label class="s-pointer" :class="{'label-active' : storageSelected === '2'}" for="2">4TB</label>
        <s-badge class="s-badge-green">{{ !togglePrice ? '$65' : '$650' }}</s-badge>
      </div>
    </section>

    <section class="s-plans-container-upgrade-cta">
      <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill lite s-button-pillborder s-button-height s-margin-auto s-button-link-hover"  iconFontAfter="s-icon-plan-lite"  v-if="planSelected === 'lite'" >{{ $t('actions.subscribe-to-lite') }}</s-button>
      <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill basic s-button-pillborder s-button-height s-margin-auto s-button-link-hover"  iconFontAfter="s-icon-plan-basic"  v-if="planSelected === 'basic'" >{{planSubscribed === 'pro' || planSubscribed === 'master' ? $t('actions.change') : $t('actions.upgrade')}} {{ $t('plans-container.to-basic-title') }}</s-button>
      <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill pro s-button-pillborder s-button-height s-margin-auto s-button-link-hover"    iconFontAfter="s-icon-plan-pro"    v-if="planSelected === 'pro'"   >{{planSubscribed === 'master' ? $t('actions.change') : $t('actions.upgrade')}} {{ $t('plans-container.to-pro-title') }}</s-button>
      <s-button @click="$emit('toNextStep')"  class="s-button-upgrade-fill master s-button-pillborder s-button-height s-margin-auto s-button-link-hover" iconFontAfter="s-icon-plan-master" v-if="planSelected === 'master'">{{ $t('actions.upgrade') }} {{ $t('plans-container.to-master-title') }} {{addStorageExtension}}</s-button>
      <s-button @click="$emit('planSelected', planSelected = 'pro')" class="s-button-upgrade-fill premium s-button-pillborder s-button-height s-margin-auto s-button-link-hover" iconFontAfter="s-icon-premium" v-if="planSubscribed === 'start' && planSelected === 'lite'" >{{ $t('plans-container.start-with-title') + " " + $t('plans-container.premium-button')}}</s-button>
      <s-button @click="$emit('planSelected', planSelected = 'lite')" class="s-button-upgrade-fill lite s-button-pillborder s-button-height s-margin-auto s-button-link-hover" iconFontAfter="s-icon-plan-lite" v-if="planSubscribed === 'start' && planSelected !== 'lite'" >{{ $t('plans-container.start-with-title') + " " + $t('plans-container.lite-button')}}</s-button>

    </section>


  </div>
</template>

<script>
import SIcon from '@/components/SIcon.vue'
import SButton from '@/components/SButton.vue'
import SToggle from '@/components/SToggle.vue'
import SBadge from '@/components/SBadge.vue'
import SPlanDetails from '@/components/SPlanDetails.vue'
import SPlanFeatures from '@/components/SPlanFeatures.vue'

export default {
  components: {
    SIcon,
    SButton,
    SToggle,
    SBadge,
    SPlanDetails,
    SPlanFeatures
  },
  props: {
    planSubscribed: {
      type: String,
      default: false
    },
    planSelected: {
      type: String,
      default: false
    },
  },
  data () {
    return {
      showPlans: true,
      togglePrice: false,
      storageSelected: 0,
    }
  },
  computed: {
    addStorageExtension () {
      switch (this.storageSelected) {
        case '0':
          return ' 1TB'
        case '1':
          return ' 2TB'
        case '2':
          return ' 5TB'
          // case "3":
          //   return
        default:
          return ''
      }
    },
    showLiteButton () {
      if (this.planSelected === 'start' || !this.planSelected) {
        if (this.planSubscribed === 'start' || this.planSubscribed === 'trial') return true
      }
      return ''
    }
  },
  methods: {
  }
}
</script>
